import Button from "@mostrans/web-components/components/base/Button";
import { Paper } from "@mui/material";
import React from "react";
import DownloadIcon from '@mui/icons-material/Download';

function CfitResult(props) {
  const { dataCandidateByID } = props;
  return (
    <React.Fragment>
      {/* <div className="form-row">
        <div className="col-md-12" style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            color="primary"
            startIcon={<DownloadIcon />}
          >
            Export
          </Button>
        </div>
      </div> */}
      <div className="form-row mt-2">
        <div className="col-md-12">
          {dataCandidateByID.CFIT ? (
            <Paper
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                height: 240,
              }}
            >
              <h1 style={{ display: "flex", justifyContent: "center" }}>
                IQ : {dataCandidateByID.CFIT.iq}
              </h1>
              <h1
                style={{
                  display: "flex",
                  justifyContent: "center",
                  color: "#0A8C4A",
                }}
              >
                Result : {dataCandidateByID.CFIT.result}
              </h1>
            </Paper>
          ) : (
            <p>Hasil CFIT Belum Tersedia</p>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default CfitResult;
